module.exports = __webpack_public_path__ + "img/斋藤拓实.2be9e279.png";